module.exports = __webpack_public_path__ + "img/common-path.2f455a2c.svg";